/* tslint:disable */
/* eslint-disable */

/**
 * 0 = TaskAdded
 * 
 * 1 = TaskRemoved
 * 
 * 2 = TaskCompleted
 * 
 * 3 = TaskCommented
 */
export enum SwimlaneAction {
  TaskAdded = 0,
  TaskRemoved = 1,
  TaskCompleted = 2,
  TaskCommented = 3
}
